import React from 'react';
import './SpinningComponent.css';

const SpinningCard = ({ imageSrc, backImage }) => {
  return (
    <div className="flex justify-center items-center mt-10 animate-title-move">
      <div className="relative perspective">
        {/* Card Container */}
        <div
          className="transform-style-preserve-3d animate-spin-3d animate-float"
          style={{
            width: 'clamp(200px, 50vw, 384px)', // Responsive scaling from 200px to 384px based on screen size
            height: 'clamp(200px, 50vw, 384px)',
          }}
        >
          {/* Front Side */}
          <div
            className="absolute w-full h-full backface-hidden"
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <img
              src={imageSrc}
              alt="Front"
              className="w-full h-full object-cover rounded-xl shadow-lg"
            />
          </div>
          {/* Back Side */}
          <div
            className="absolute w-full h-full bg-black rounded-xl backface-hidden rotate-y-180 flex justify-center items-center"
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <img
              src={backImage}
              alt="Back"
              className="w-full h-full object-cover rounded-xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpinningCard;
